const SearchIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.809 12.1133C13.9366 12.2409 14.0004 12.3958 14.0004 12.5781C14.0004 12.7604 13.9366 12.9154 13.809 13.043L13.0434 13.8086C12.9158 13.9362 12.7608 14 12.5785 14C12.3962 14 12.2413 13.9362 12.1137 13.8086L9.3793 11.0742C9.25169 10.9466 9.18789 10.7917 9.18789 10.6094V10.1719C8.16706 10.974 7.00039 11.375 5.68789 11.375C4.12018 11.375 2.78034 10.819 1.66836 9.70703C0.55638 8.59505 0.00039053 7.25521 0.00039053 5.6875C0.00039053 4.11979 0.55638 2.77995 1.66836 1.66797C2.78034 0.55599 4.12018 0 5.68789 0C7.2556 0 8.59544 0.55599 9.70742 1.66797C10.8194 2.77995 11.3754 4.11979 11.3754 5.6875C11.3754 7 10.9743 8.16667 10.1723 9.1875H10.6098C10.7921 9.1875 10.947 9.2513 11.0746 9.37891L13.809 12.1133ZM3.19961 8.17578C3.89232 8.85026 4.72174 9.1875 5.68789 9.1875C6.65404 9.1875 7.47435 8.85026 8.14883 8.17578C8.84154 7.48307 9.18789 6.65365 9.18789 5.6875C9.18789 4.72135 8.84154 3.90104 8.14883 3.22656C7.47435 2.53385 6.65404 2.1875 5.68789 2.1875C4.72174 2.1875 3.89232 2.53385 3.19961 3.22656C2.52513 3.90104 2.18789 4.72135 2.18789 5.6875C2.18789 6.65365 2.52513 7.48307 3.19961 8.17578Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SearchIcon;
